import React from 'react';
import classNames from 'classnames';

export interface CardFooterProps {
  children: React.ReactNode;
  className?: string;
  exdent?: boolean;
  id?: string;
}

/**
 * The Card Footer based on [The USWDS card component](https://designsystem.digital.gov/components/card/)
 *
 */
const CardFooter = ({ children, className, id, exdent }: CardFooterProps): JSX.Element => {
  const cardFooterClasses = classNames(className, {
    'usa-card__footer': true,
    'usa-card__footer--exdent': exdent,
  });

  return (
    <div id={id} className={cardFooterClasses}>
      {children}
    </div>
  );
};

export default CardFooter;
